import { Container, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { Button, InputRadio } from "../../controls";
import { Alert, Form } from "../../layout";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { useTranslation } from "react-i18next";

const DefBranch = (props) => {
  const { t } = useTranslation();
  const { branches, setBranches } = useContext(AppContext);
  const [defBranchId, setDefBranchId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    var defBranch = branches.find((j) => j.defBranch);
    defBranch && setDefBranchId(defBranch.id);
    return () => {};
  }, [branches]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const onComplete = (res) => {
      setLoading(false);
      if (res.status === 200) {
        setAlert({
          isOpen: true,
          type: "success",
          title: t("Success"),
          subTitle: t("BranchDltSuccessTitle"),
        });
        setBranches((x) => [
          ...x.map((j) =>
            j.id === res.result.id
              ? { ...res.result, label: res.result.name }
              : j
          ),
        ]);
      } else
        setAlert({
          isOpen: true,
          type: "error",
          title: t("Error"),
          subTitle: t("DltErrTitle"),
        });
    };

    API(endpoints.Branch + actions.SetDefBranch).getById(
      defBranchId,
      onComplete
    );
  };

  const handleInpChange = (e) => {
    setDefBranchId(parseInt(e.target.value));
  };
  return (
    <Container maxWidth="sm" sx={{ padding: "0px !important" }}>
      <Form noValidate onSubmit={handleSubmit}>
        <Paper className="br-8 shadow-xs p-20">
          <Box className="tx-center mb-20">
            <Typography
              variant="subtitle1"
              className="fs-22 gray-color fw-5 tx-upp"
            >
              {t("SetDefaultBranch")}
            </Typography>
            <div className="border-bottom w-60 m-auto" />
          </Box>
          <Box
            sx={{
              ml: { md: "80px" },
              maxHeight: "calc(100vh - 290px)",
              overflow: "auto",
            }}
          >
            <InputRadio
              options={branches}
              value={defBranchId}
              row={false}
              onChange={handleInpChange}
            />
          </Box>
          <Box className="tx-center mt-30">
            <Button loading={loading} type="submit" variant="text" size="large">
              {t("SubmitDifBranch")}
            </Button>
          </Box>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </Container>
  );
};

export default DefBranch;
